import React from 'react'

function HeaderActions({
  handleOpenCliInviteModal,
  handleCloseCliInviteModal,
  isCliInviteModalOpen,
  isCliInvMailLoading,
  pendingInvitesCountLoading,
  user,
  navigate,
  clientPendingInvitesCount,
  handleCliInviteSubmit,
  cliInvEmails,
  cliInvEmail,
  setCliInvEmail,
  handleEditCliInvEmail,
  handleRemoveCliInvEmail,
  handleRemoveLatestCliInvEmail,
  handleAddCliInvEmail,
  isResendCliInviteModalOpen,
  handleCloseResendCliInviteModal,
  alreadySentCliInvEmailsList,
  handleRemoveResendCliInvEmail,
  handleResendCliInvEmails,
  userTypeConsts,
  InviteIcon,
  Modal,
  ThreeDots,
  dletImage,
  addicon,
  DownloadImage,
  exportToExcel,
  isExportFetching,
  handleBulkImportOpenModal,
  isBulkImportModalOpen,
  crssrImage,
  isBulkImportLoading,
  handleBulkImportCloseModal,
  bulkImportFileName,
  handleBulkImportUpload,
  Plus,
  handleUpload,
  handleOpenModal,
  PlusIcon,
  appSettings,
  isModalOpen,
  handleCloseModal,
  handleSubmit,
  clientName,
  setClientName,
  legalEntityName,
  shortName,
  setShortName,
  setLegalEntityName,
  email,
  setEmail,
  PhoneInput,
  mobileNo,
  setMobileNo,
  companyWebsite,
  setCompanyWebsite,
  isValidUrl,
  companyLogoName,
  handleLogoUpload,
  accManagerSelectDropdownRef,
  accManagerDropdownOpen,
  handleToggleAccManagerDropdown,
  accManagerIsValid,
  accManagerRef,
  accManager,
  userIds,
  userSearchTerm,
  handleAccManagerSearchInputChange,
  filteredUsers,
  handleSelectAccManager,
  address,
  setAddress,
  country,
  setCountry,
  countryDropdownRef,
  handleToggleCountryDropdown,
  countryDropdownOpen,
  countrySearchTerm,
  handleCountrySearchInputChange,
  filteredCountries,
  setCountryDropdownOpen,
  state,
  setState,
  stateDropdownRef,
  handleToggleStateDropdown,
  stateDropdownOpen,
  stateSearchTerm,
  handleStateSearchInputChange,
  filteredStates,
  setStateDropdownOpen,
  states,
  showPassword,
  passwordError,
  password,
  setPassword,
  passwordRef,
  EyeCrossed,
  EyeIcon,
  setShowPassword,
  passwordMatchError,
  passwordConfirmation,
  setPasswordConfirmation,
  passwordConfirmationRef,
  additionalInfo,
  setAdditionalInfo,
  isSubmitLoading,

  setAccManagerIsValid,
  setContactPointIsValid,
  setIsValidUrl,
  setPasswordMatchError,
  setPasswordError,
  companyLogo,
  toast,
  token,
  refetchClientProfiles,
  setIsSubmitLoading,
  setUpdateClientList,
  updateClientList,
  dispatch,
  logout,
  reset,
  invoiceReset,
  headerReset,
  appSettingsReset


}) {
  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="outer-client-overview-sec">
        <div className="invite-client-outer invite-client-outer-client-overview">

          {(user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN)) && (
            <a className="btn-invite-client" onClick={handleOpenCliInviteModal}>
              <span className="icon-invite">
                <img src={InviteIcon} alt="invite" />
              </span>
              Invite Client
            </a>
          )}

          <Modal
            isOpen={isCliInviteModalOpen}
            onRequestClose={
              !isCliInvMailLoading ? handleCloseCliInviteModal : undefined
            }
            contentLabel="Invite a User"
            className="user-invite-modal-main-outer"
            style={{
              content: {
                height: "41%",
                width: "30%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              },
            }}
          >
            <div className="modal">
              <div className="modal-top-section-user-invite with-pending-outer">
                <div className="modal-invite-head">
                  <h2 className="">Invite a new Client</h2>
                </div>
                <div className="modal-close-invite outter-modal-main outter-modal-main-user with-pending">
                  <div
                    className="pending-invitation"
                    onClick={() => {
                      localStorage.setItem('activeTab', "9");
                      navigate("/user/account/settings");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="pending-invitation-count">
                      {pendingInvitesCountLoading ? (
                        <div
                          style={{
                            width: "32px",
                            height: "18px",
                            borderRadius: "999px",
                            backgroundColor: "#e5e7eb",
                            animation: "pulse 1.5s ease-in-out infinite",
                            margin: "0 auto",
                          }}
                        />
                      ) : (
                        clientPendingInvitesCount
                      )}
                    </div>
                    <div className="pending-invitation-text">
                      Pending invitations
                    </div>
                  </div>
                  <a
                    className=""
                    onClick={handleCloseCliInviteModal}
                    disabled={isCliInvMailLoading}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M1 13L13 1" stroke="black" />
                      <path d="M1 0.999999L13 13" stroke="black" />
                    </svg>
                  </a>
                </div>
              </div>

              <form onSubmit={handleCliInviteSubmit}>
                <div>
                  {cliInvEmails.map((obj) => (
                    <div key={obj.id} className="the-modal-inuser">
                      <div className="user-add-outer-innner">
                        <div className="invite-user">
                          <label htmlFor="grid-password" className="">
                            Email Address
                          </label>
                          <input
                            type="email"
                            id={`email-${obj.id}`}
                            className=""
                            name="email"
                            required
                            placeholder="Enter Email ID"
                            value={obj.cliInvEmail}
                            onChange={(e) =>
                              handleEditCliInvEmail(
                                obj.id,
                                "cliInvEmail",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div
                          className="invite-user-delete"
                          onClick={() => handleRemoveCliInvEmail(obj.id)}
                        >
                          <img src={dletImage} alt="delete-icon" />{" "}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="the-modal-inuser">
                    <div className="user-add-outer-innner">
                      <div className="invite-user">
                        <label htmlFor="grid-password" className="">
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          className=""
                          placeholder="Enter Email ID"
                          value={cliInvEmail}
                          onChange={(e) => setCliInvEmail(e.target.value)}
                        />
                      </div>
                      {cliInvEmails.length > 0 && (
                        <div
                          className="invite-user-delete"
                          onClick={handleRemoveLatestCliInvEmail}
                        >
                          <img src={dletImage} alt="delete-icon" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className="add-email-sec-modal"
                    onClick={handleAddCliInvEmail}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={addicon} alt="Edit Icon" />
                    <div className="add-icon-main-text">Add new email</div>
                  </div>
                </div>
                <div className="invite-mail-popup-btn">
                  <button
                    type="submit"
                    className=""
                    disabled={isCliInvMailLoading}
                  >
                    {isCliInvMailLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      "Send Invite"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Modal>

          <Modal
            isOpen={isResendCliInviteModalOpen}
            onRequestClose={
              !isCliInvMailLoading
                ? handleCloseResendCliInviteModal
                : undefined
            }
            contentLabel="Resend Invitations"
            style={{
              content: {
                height: "41%",
                width: "30%",
                position: "fixed",
                top: "50%",
                left: "50%",
              },
            }}
          >
            <div className="modal">
              <div className="modal-close-invite outter-modal-main">
                <a
                  className=""
                  onClick={handleCloseResendCliInviteModal}
                  disabled={isCliInvMailLoading}
                >
                  <img src={crssrImage} alt="Edit Icon" />{" "}
                </a>
              </div>
              <div className="modal-invite-head">
                <h2 className="">Resend Invitations</h2>
              </div>
              {/* List the already sent emails here */}
              <div>
                <div className="the-modal-inuser">
                  <label htmlFor="grid-password" className="">
                    Email
                  </label>
                  {alreadySentCliInvEmailsList.map((email) => (
                    <div key={email} className="the-modal-inusers">
                      <div className="resend-invitation">
                        <input
                          type="email"
                          className=""
                          name="email"
                          required
                          placeholder="Enter Email ID"
                          value={email}
                          disabled
                        />
                        {alreadySentCliInvEmailsList.length > 1 && (
                          <button
                            className="del-resend"
                            onClick={() =>
                              handleRemoveResendCliInvEmail(email)
                            }
                          >
                            <img src={dletImage} alt="delete-icon" />{" "}
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="sprint-btn-outer resend-invoice">
                <button
                  type="button"
                  onClick={handleCloseResendCliInviteModal}
                  disabled={isCliInvMailLoading}
                  className="submit-client cancel-sprint"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="submit-client save-sprint"
                  disabled={isCliInvMailLoading}
                  onClick={handleResendCliInvEmails}
                >
                  {isCliInvMailLoading ? (
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        border: "2px solid #ffffff",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        margin: "0 auto",
                      }}
                    />
                  ) : (
                    "Resend Invitations"
                  )}
                </button>
              </div>
            </div>
          </Modal>

          <a
            className="btn-invite-client bulk-export"
            onClick={!isExportFetching ? exportToExcel : undefined}
            style={{ pointerEvents: isExportFetching ? 'none' : 'auto', minWidth: '130px' }}
          >
            {isExportFetching ? (
              <ThreeDots
                height="18"
                width="36"
                radius="4"
                color="#ffffff"
                ariaLabel="three-dots-loading"
                visible={true}
              />
            ) : (
              <>
                <span className="icon-invoice">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Export Data
              </>
            )}
          </a>

          {(user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN)) && (
            <a className="btn-invite-client bulk-import" onClick={handleBulkImportOpenModal} >
              <span className="icon-invoice">
                <img src={DownloadImage} alt="Export" />
              </span>
              Bulk Import
            </a>
          )}

          <Modal
            isOpen={isBulkImportModalOpen}
            onRequestClose={
              !isBulkImportLoading ? handleBulkImportCloseModal : undefined
            }
            contentLabel="Invite a User"
            className="bulk-import-popup"
            style={{
              content: {
                height: "50%",
                width: "50%",
                position: "fixed",
                top: "50%",
                left: "50%",
              },
            }}
          >
            <div className="modal">
              <div className="modal-top-section-user-invite">
                <div className="modal-invite-head">
                  <h2 className="">Bulk Import</h2>
                </div>
                <div className="modal-close-invite outter-modal-main outter-modal-main-user">
                  <a
                    className=""
                    onClick={handleBulkImportCloseModal}
                    disabled={isBulkImportLoading}
                  >
                    <img src={crssrImage} alt="Close Bulk Import" />{" "}
                  </a>
                </div>
              </div>

              <form>
                <div className="relative w-full mb-3">
                  <div className="file-input-wrapper">
                    <input
                      type="text"
                      className="form-input form-input-file"
                      value={bulkImportFileName}
                      readOnly
                    />
                    <input
                      type="file"
                      id="expFileAttchEdit"
                      name="expFileAttchEdit"
                      className="form-input hidden-input"
                      onChange={handleBulkImportUpload}
                    // required
                    />
                    <label
                      htmlFor="expFileAttch"
                      className="file-input-label"
                    >
                      <img src={Plus} alt="Browse" />
                      Browse
                    </label>
                  </div>
                  <div className="text-sm bulk-text">
                    Demo File: {"    "}
                    <a
                      href="https://docs.google.com/spreadsheets/d/1u5GFHWbJkYVFn0k2X0myPw-nZUinKhcLzCsePbpuVD4/edit?usp=sharing"
                      className="form-textarea"
                      target="_blank"
                    >
                      Import_demo.xlsx
                    </a>
                  </div>
                </div>

                <div className="bulk-btn-section sprint-btn-outer">
                  <button
                    className="submit-client cancel-sprint"
                    type="button"
                    onClick={handleBulkImportCloseModal}
                    disabled={isBulkImportLoading}
                  >
                    Close
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-full shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleUpload}
                    disabled={isBulkImportLoading}
                  >
                    {isBulkImportLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      "Send"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Modal>

          {(user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN)) && (
            <a className="new-client" onClick={handleOpenModal}>
              <span className="icon-invoice">
                <img src={PlusIcon} alt="New Client" />
              </span>
              {global.config.locate(
                appSettings && appSettings.language,
                "New Client"
              )}
            </a>
          )}

          <Modal
            className="client-modal"
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            contentLabel="New Client Account"
            style={{
              content: {
                height: "41%",
                width: "30%",
                position: "fixed",
                top: "50%",
                left: "50%",
                parent: document.querySelector(".admin-outer.time.tracker"),
              },
            }}
          >
            <div className="modal">
              <div className="modal-close-invite outter-modal-main">
                <a className="" onClick={handleCloseModal}>
                  <img src={crssrImage} alt="Edit Icon" />{" "}
                </a>
              </div>
              <div className="modal-client-head">
                <h2 className="">
                  {global.config.locate(
                    appSettings && appSettings.language,
                    "New Client Account"
                  )}
                </h2>
              </div>
              <div className="form-field-client-outer profile-details-edit">
                {/* <form onSubmit={() => handleSubmit(event, setAccManagerIsValid, setContactPointIsValid, setIsValidUrl, setPasswordMatchError, setPasswordError, accManager, clientName, password, passwordConfirmation, companyWebsite, companyLogo, country, state, address, additionalInfo, toast,
                  accManagerRef, passwordRef, passwordConfirmationRef, email, mobileNo, legalEntityName, token, navigate, handleCloseModal, refetchClientProfiles, setIsSubmitLoading, setUpdateClientList, updateClientList, dispatch, logout, reset, invoiceReset, headerReset, appSettingsReset, global)}>
                   */}
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="form-field-client">
                    <label htmlFor="clientName" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Commercial_Name"
                      )}
                    </label>
                    <input
                      type="text"
                      id="clientName"
                      name="clientName"
                      className="form-input"
                      value={clientName}
                      onChange={(e) => setClientName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="legalEntityName" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Legal_Entity_Name"
                      )}
                    </label>
                    <input
                      type="text"
                      id="legalEntityName "
                      name="legalEntityName"
                      className="form-input"
                      value={legalEntityName}
                      onChange={(e) => setLegalEntityName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="legalEntityName" className="form-label">
                      Short Name
                    </label>
                    <input
                      type="text"
                      id="shortName"
                      name="shortName"
                      className="form-input"
                      value={shortName}
                      onChange={(e) => setShortName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="emailAddress" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Email Address"
                      )}
                    </label>
                    <input
                      type="email"
                      id="emailAddress"
                      name="emailAddress"
                      className="form-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="inner-detail-inner form-field-client">
                    <label htmlFor="mobileNo" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Mobile_No"
                      )}
                    </label>
                    <PhoneInput
                      placeholder="Enter phone number"
                      value={mobileNo}
                      onChange={setMobileNo}
                    />
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="companyWebsite" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Company Website"
                      )}
                    </label>
                    <input
                      type="text"
                      id="companyWebsite"
                      name="companyWebsite"
                      className="form-input"
                      value={companyWebsite}
                      onChange={(e) => setCompanyWebsite(e.target.value)}
                    />
                    {isValidUrl && (
                      <span className="text-red-500 text-xs italic">
                        Please enter a valid URL!!
                      </span>
                    )}
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="companyLogo" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Company Logo"
                      )}
                    </label>
                    <div className="file-input-wrapper">
                      <input
                        type="text"
                        className="form-input form-input-file"
                        value={companyLogoName}
                        readOnly
                      />
                      <input
                        type="file"
                        id="companyLogo"
                        name="companyLogo"
                        className="form-input hidden-input"
                        accept="image/*"
                        onChange={handleLogoUpload}
                        required
                      />
                      <label
                        htmlFor="companyLogo"
                        className="file-input-label"
                      >
                        <img src={Plus} alt="Browse" />
                        Browse
                      </label>
                    </div>
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="client" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Account Manager"
                      )}
                    </label>

                    <div
                      ref={accManagerSelectDropdownRef}
                      className={`cursor ${accManagerDropdownOpen ? "open" : ""
                        }`}
                    >
                      <span
                        id="user-select"
                        onClick={handleToggleAccManagerDropdown}
                        className={`custom-dropdown-user-new custom-dropdown-user ${accManagerIsValid ? "input-validation-error" : ""
                          }`}
                        ref={accManagerRef}
                      >
                        {accManager ? (
                          userIds?.find((user) => user._id === accManager)
                            ?.first_name ? (
                            <>
                              {
                                userIds?.find(
                                  (user) => user._id === accManager
                                )?.first_name
                              }{" "}
                              {userIds?.find(
                                (user) => user._id === accManager
                              )?.middle_name &&
                                userIds?.find((user) => user._id === accManager)
                                  ?.middle_name !== "null"
                                ? userIds?.find(
                                  (user) => user._id === accManager
                                )?.middle_name + " "
                                : ""}
                              {
                                userIds?.find(
                                  (user) => user._id === accManager
                                )?.last_name
                              }{" "}
                            </>
                          ) : (
                            <>
                              {userIds.find((user) => user._id === accManager)
                                ?.company_first_name
                                ? `${userIds.find(
                                  (user) => user._id === accManager
                                )?.company_first_name
                                } ${userIds.find(
                                  (user) => user._id === accManager
                                )?.company_last_name
                                  ? userIds.find(
                                    (user) => user._id === accManager
                                  )?.company_last_name
                                  : ""
                                }`
                                : `${userIds.find(
                                  (user) => user._id === accManager
                                )?.company_name || ""
                                }(Company)`}
                            </>
                          )
                        ) : (
                          global.config.locate(
                            appSettings && appSettings.language,
                            "Select Account Manager"
                          )
                        )}
                      </span>
                      {accManagerDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <input
                            type="text"
                            className="search-bar"
                            placeholder={global.config.locate(
                              appSettings && appSettings.language,
                              "Search"
                            )}
                            value={userSearchTerm}
                            onChange={handleAccManagerSearchInputChange}
                          />
                          <ul className="client-list">
                            {filteredUsers.length > 0 &&
                              filteredUsers
                                .slice()
                                .sort((a, b) => {
                                  const nameA = a.first_name
                                    ? `${a.first_name} ${a.middle_name || ""
                                    } ${a.last_name}`
                                    : `${a.company_first_name
                                      ? a.company_first_name +
                                      (a.company_last_name &&
                                        a.company_last_name)
                                      : a.company_name
                                    }`;
                                  const nameB = b.first_name
                                    ? `${b.first_name} ${b.middle_name || ""
                                    } ${b.last_name}`
                                    : `${b.company_first_name
                                      ? b.company_first_name +
                                      (b.company_last_name &&
                                        b.company_last_name)
                                      : b.company_name
                                    }`;
                                  return nameA.localeCompare(nameB);
                                })
                                .map((item) => (
                                  <li
                                    key={item._id}
                                    className={
                                      accManager === item._id
                                        ? "selected-item"
                                        : ""
                                    }
                                    onClick={() =>
                                      handleSelectAccManager(item._id)
                                    }
                                  >
                                    {item.first_name ? (
                                      <>
                                        {item.first_name}{" "}
                                        {item.middle_name &&
                                          item.middle_name !== "null"
                                          ? item.middle_name + " "
                                          : ""}
                                        {item.last_name}{" "}
                                      </>
                                    ) : (
                                      <>
                                        {item.company_first_name
                                          ? `${item.company_first_name} ${item.company_last_name
                                            ? item.company_last_name
                                            : ""
                                          }`
                                          : `${item.company_name || ""
                                          }(Company)`}
                                      </>
                                    )}
                                  </li>
                                ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {accManagerIsValid && (
                      <span className="text-red-500 text-xs italic">
                        Account Manager needs to be selected
                      </span>
                    )}
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="address" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Address"
                      )}
                    </label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      className="form-input"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="country" className="form-label">
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Country"
                      )}
                    </label>
                    <div
                      ref={countryDropdownRef}
                      className="select-modal-mainM custom-dropdown-user-new-outer"
                    >
                      <span
                        id="country"
                        onClick={handleToggleCountryDropdown}
                        className="custom-dropdown-user-new"
                      >
                        {country
                          ? country
                          : appSettings && appSettings.language
                            ? global.config.locate(
                              appSettings.language,
                              "Select Country"
                            )
                            : null}
                      </span>
                      {countryDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <input
                            type="text"
                            className="search-bar"
                            placeholder={global.config.locate(
                              appSettings && appSettings.language,
                              "Search"
                            )}
                            value={countrySearchTerm}
                            onChange={handleCountrySearchInputChange}
                          />
                          <ul className="country-list">
                            {filteredCountries.length > 0 &&
                              filteredCountries.map((c) => (
                                <li
                                  key={c.country}
                                  className={
                                    country === c.country
                                      ? "selected-item"
                                      : ""
                                  }
                                  onClick={() => {
                                    setCountry(c.country);
                                    setCountryDropdownOpen(false);
                                  }}
                                >
                                  {c.country}
                                </li>
                              ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  {states.length > 0 && (
                    <div className="form-field-client">
                      <label htmlFor="state" className="form-label">
                        {global.config.locate(appSettings && appSettings.language, 'State')}
                      </label>
                      <div ref={stateDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
                        <span
                          id="state"
                          onClick={handleToggleStateDropdown}
                          className="custom-dropdown-user-new"
                        >
                          {state ? states.find((s) => s.state === state)?.state : 'Select State'}
                        </span>
                        {stateDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <input
                              type="text"
                              className="search-bar"
                              placeholder="Search..."
                              value={stateSearchTerm}
                              onChange={handleStateSearchInputChange}
                            />
                            <ul className="state-list">
                              {filteredStates.length > 0 &&
                                filteredStates.map((s) => (
                                  <li
                                    key={s.state}
                                    className={state === s.state ? 'selected-item' : ''}
                                    onClick={() => {
                                      setState(s.state);
                                      setStateDropdownOpen(false);
                                    }}
                                  >
                                    {s.state}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="form-field-client">
                    <label htmlFor="password" className="form-label">
                      New Password
                    </label>
                    <div className="pass-eye">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        id="password"
                        className={
                          passwordError
                            ? "input-validation-error form-input"
                            : "form-input"
                        }
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        ref={passwordRef}
                      />
                      <img
                        src={showPassword ? EyeCrossed : EyeIcon}
                        className="password-toggle-icon"
                        alt="Toggle Password"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    {passwordError && (
                      <span className="text-red-500 text-xs italic">
                        {passwordError}
                      </span>
                    )}
                  </div>
                  <div className="form-field-client">
                    <label htmlFor="confPassword" className="form-label">
                      Confirm new Password
                    </label>
                    <input
                      type="password"
                      className={
                        passwordMatchError
                          ? "input-validation-error form-input"
                          : "form-input"
                      }
                      value={passwordConfirmation}
                      onChange={(e) =>
                        setPasswordConfirmation(e.target.value)
                      }
                      ref={passwordConfirmationRef}
                    />
                    {passwordMatchError && (
                      <span className="text-red-500 text-xs italic">
                        {passwordMatchError}
                      </span>
                    )}
                  </div>
                  <div className="form-field-client">
                    <label
                      htmlFor="additionalInformation"
                      className="form-label"
                    >
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Additional Information"
                      )}
                    </label>
                    <textarea
                      id="additionalInformation"
                      name="additionalInformation"
                      className="form-textarea"
                      rows="4"
                      value={additionalInfo}
                      onChange={(e) => setAdditionalInfo(e.target.value)}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="submit-client"
                    disabled={isSubmitLoading}
                  >
                    {isSubmitLoading ? (
                      <div
                        style={{
                          width: "18px",
                          height: "18px",
                          border: "2px solid #ffffff",
                          borderTop: "2px solid transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      global.config.locate(
                        appSettings && appSettings.language,
                        "Create Client"
                      )
                    )}
                  </button>
                </form>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  )
}

export default HeaderActions